import './cutscene.scss';
import { useEffect, useState } from 'react';
import { GameContext } from '@game-libs/models';
import { GUIOverlay } from '@game-libs/gui-overlay';
import { GlobalGameStore } from '@game-libs/global-game-store';

const { openOverlay } = GUIOverlay();

export const CutsceneOverlay = () => {
  const [isOpen, setIsOpen] = useState(false);

  const { state } = GlobalGameStore();

  useEffect(() => {
    const unsub = state.context.subscribe((context) => {
      if (context !== GameContext.CUTSCENE) {
        setIsOpen(false);
      } else {
        setIsOpen(true);
      }
    });

    return unsub;
  }, []);

  return (
    <div className={'cutscene-overlay ' + (isOpen ? 'open' : 'closed')}>
      <div className="top-overlay"></div>
      <div className="bottom-overlay"></div>
    </div>
  );
};

export const openCutsceneOverlay = () => {
  openOverlay(<CutsceneOverlay />);
};
